import React from "react";
import { Container, Paragraph, Title } from "./style";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";

interface IModalReservationsProps {
  onCancel: Function;
  openModal: boolean;
  backgroundVisible?: boolean;
}

const texts: any = {
  title: "Política de Privacidade",
  subTitle: "",
};

export const ModalPrivacyPolicy: React.FC<IModalReservationsProps> = (props) => {
  const { onCancel, openModal, backgroundVisible } = props;

  return (
    <ModalGeneric
      backgroundVisible={backgroundVisible}
      open={openModal}
      onClose={() => { }}
    >
      <Container>
        <ModalHeader
          title={texts.title}
          subTitle={texts.subTitle}
          onCancel={() => onCancel()}
          theme='light'
        />
        <div style={{ overflowY: 'scroll', paddingTop: 20 }}>
          <Paragraph>
            <b>Housy Tecnologia LTDA</b>, pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o nº <b>44.058.943/0001-40</b>, com sede na cidade de <b>Barreiras/BA</b>, doravante denominada simplesmente <b>“Housy“</b>, estabelece a presente Política de Privacidade para regular o tratamento de dados pessoais no âmbito do sistema <b>Webcheckin.app</b>.
          </Paragraph>

          <Title>
            1. INTRODUÇÃO
          </Title>

          <Paragraph>
            Desta forma, os objetivos desta Política de Privacidade e Proteção (“Política”) são esclarecer aos titulares dos dados como a WE.HOUSY salvaguarda as informações pessoais obtidas através do seu site, em especial durante o uso dos Portais de Clientes e Investidores, e as metodologias empregadas para oferecer um serviço de excelência.
          </Paragraph>

          <Title>
            2. DEFINIÇÕES
          </Title>

          <Paragraph>
            Para os fins desta Política de Privacidade, aplicam-se as seguintes definições:

            <ul>
              <li>
                <b>Dados Pessoais:</b> informações relacionadas a pessoa natural identificada ou identificável.
              </li>
              <li>
                <b>Tratamento: </b>toda operação realizada com dados pessoais, como coleta, uso, armazenamento, compartilhamento, eliminação, entre outras.
              </li>
              <li>
                <b>Titular:</b> pessoa natural a quem se referem os dados pessoais.
              </li>
              <li>
                <b>Controlador:</b> pessoa natural ou jurídica a quem competem as decisões referentes ao tratamento de dados pessoais.
              </li>
              <li>
                <b>Operador:</b> pessoa natural ou jurídica que realiza o tratamento de dados pessoais em nome do controlador.
              </li>
            </ul>
          </Paragraph>

          <Title>
            3. DADOS COLETADOS
          </Title>

          <Paragraph>
            O Webcheckin.app coleta os seguintes dados pessoais:
            <ul>
              <li>
                Dados de identificação: nome, CPF/CNPJ, RG, data de nascimento, nacionalidade.
              </li>
              <li>
                Dados de contato: e-mail, telefone.
              </li>
              <li>
                Dados de hospedagem: datas de check-in e check-out, número de hóspedes, informações sobre a acomodação.
              </li>
              <li>
                Documentos: cópias digitalizadas de documentos de identidade, passaportes, vistos, entre outros.
              </li>
              <li>
                Dados de acesso: endereços IP, logs de acesso, cookies.
              </li>
            </ul>
          </Paragraph>

          <Title>
            4. FINALIDADES DO TRATAMENTO
          </Title>

          <Paragraph>
            Os dados pessoais coletados são utilizados para as seguintes finalidades:

            <ul>
              <li>
                Gerenciar o processo de check-in e check-out de hóspedes.
              </li>
              <li>
                Recolher e armazenar documentos necessários para a hospedagem.
              </li>
              <li>
                Gerar e enviar chaves eletrônicas para acesso às acomodações.
              </li>
              <li>
                Enviar mensagens relacionadas à hospedagem, como confirmações, lembretes e informações úteis.
              </li>
              <li>
                Cumprir obrigações legais e regulatórias.
              </li>
            </ul>
          </Paragraph>

          <Title>
            5. COMPARTILHAMENTO DE DADOS
          </Title>

          <Paragraph>
            A Housy poderá compartilhar dados pessoais com:

            <ul>
              <li>
                <b>Prestadores de serviços:</b> empresas que auxiliam na operação do Webcheckin.app, como provedores de hospedagem, serviços de envio de mensagens, entre outros.
              </li>
              <li>
                <b>Autoridades competentes:</b> quando necessário para cumprir obrigações legais ou regulatórias.
              </li>
            </ul>
            Todos os terceiros com quem os dados são compartilhados estão contratualmente obrigados a proteger os dados pessoais e utilizá-los apenas para as finalidades específicas para as quais foram fornecidos.
          </Paragraph>

          <Title>
            6. DIREITOS DOS TITULARES
          </Title>

          <Paragraph>
            Os titulares dos dados pessoais têm os seguintes direitos:

            <ul>
              <li>
                Confirmação da existência de tratamento.
              </li>
              <li>
                Acesso aos dados.
              </li>
              <li>
                Correção de dados incompletos, inexatos ou desatualizados.
              </li>
              <li>
                Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a LGPD.
              </li>
              <li>
                Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa.
              </li>
              <li>
                Eliminação dos dados pessoais tratados com o consentimento do titular.
              </li>
              <li>
                Informação sobre as entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados.
              </li>
              <li>
                Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa.
              </li>
              <li>
                Revogação do consentimento.
              </li>
            </ul>
            Para exercer esses direitos, o titular pode entrar em contato com a Housy através do e-mail: <b>contato@webcheckinapp.com.br</b>.
          </Paragraph>

          <Title>
            7. SEGURANÇA DOS DADOS
          </Title>

          <Paragraph>
            A Housy adota medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, perda, destruição, alteração ou qualquer forma de tratamento inadequado ou ilícito.
          </Paragraph>

          <Title>
            8. RETENÇÃO DOS DADOS
          </Title>

          <Paragraph>
            Os dados pessoais serão armazenados pelo tempo necessário para cumprir as finalidades para as quais foram coletados, incluindo para fins de cumprimento de obrigações legais, contratuais ou requisições de autoridades competentes.
          </Paragraph>

          <Title>
            9. COOKIES
          </Title>

          <Paragraph>
            O Webcheckin.app utiliza cookies e tecnologias semelhantes para melhorar a experiência do usuário, analisar o uso da plataforma e personalizar o conteúdo. O usuário pode configurar seu navegador para recusar cookies, mas isso pode afetar a funcionalidade da plataforma.
          </Paragraph>

          <Title>
            10. ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE
          </Title>

          <Paragraph>
            Esta Política de Privacidade pode ser atualizada periodicamente. Recomendamos que os usuários revisem esta política regularmente para se manterem informados sobre como protegemos seus dados.
          </Paragraph>

          <Title>
            11. CONTATO
          </Title>

          <Paragraph>
            Em caso de dúvidas sobre esta Política de Privacidade ou sobre o tratamento de dados pessoais, entre em contato com a Housy através do e-mail: <b>contato@webcheckinapp.com.br</b>.
          </Paragraph>

          <Paragraph>
            Última atualização: 28 de abril de 2025
          </Paragraph>

        </div>
      </Container>
    </ModalGeneric>
  );
};
